function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.29,111.584l103.722,36.432c7.585,3.328,16.435-0.124,19.763-7.711s-0.125-16.433-7.711-19.763L65.342,84.11 c-7.585-3.328-16.435,0.124-19.763,7.711C42.251,99.408,45.704,108.256,53.29,111.584L53.29,111.584z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.225,189.81l103.722,36.432c7.585,3.328,16.435-0.124,19.763-7.711s-0.125-16.433-7.711-19.762L69.277,162.338 c-7.585-3.328-16.435,0.124-19.763,7.711C46.186,177.634,49.639,186.482,57.225,189.81L57.225,189.81z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.16,268.036l103.722,36.432c7.585,3.328,16.435-0.124,19.763-7.711c3.328-7.587-0.125-16.434-7.711-19.763 L73.212,240.563c-7.585-3.328-16.435,0.124-19.763,7.711C50.122,255.86,53.575,264.708,61.16,268.036L61.16,268.036z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M389.275,111.584c7.586-3.328,11.039-12.176,7.711-19.763c-3.328-7.587-12.178-11.039-19.763-7.711l-103.722,36.432 c-7.586,3.329-11.039,12.176-7.711,19.763c3.328,7.587,12.178,11.039,19.763,7.711L389.275,111.584L389.275,111.584z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M385.34,189.81c7.586-3.328,11.039-12.176,7.711-19.762c-3.328-7.587-12.178-11.039-19.763-7.711l-103.722,36.432 c-7.586,3.328-11.039,12.175-7.711,19.762s12.178,11.039,19.763,7.711L385.34,189.81L385.34,189.81z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M381.405,268.036c7.586-3.328,11.039-12.176,7.711-19.763c-3.328-7.587-12.178-11.039-19.763-7.711l-103.722,36.432 c-7.586,3.329-11.039,12.176-7.711,19.763c3.328,7.587,12.178,11.039,19.763,7.711L381.405,268.036L381.405,268.036z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M443.732,8.534c0-2.56-1.706-5.12-3.413-6.827C437.76,0,435.2,0,432.64,0L222.294,67.311l-0.427-0.137v0l0,0l0,0v0 l-0.427,0.137L11.093,0c-2.56,0-5.12,0-7.68,1.707C1.706,3.414,0,5.974,0,8.534l0,302.532c0,3.413,2.56,6.827,5.973,8.533 l189.24,59.738v0.213c0,3.514,2.849,6.363,6.363,6.363h20.29h0h20.29c3.514,0,6.363-2.849,6.363-6.363v-0.213l189.24-59.738 c3.413-1.706,5.973-5.12,5.973-8.533L443.732,8.534z M206.975,355.814L25.583,295.823V31.72l181.392,56.789V355.814z  M418.149,295.823l-181.392,59.991V88.509L418.149,31.72V295.823z"
});

function SvgManuals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "443.733px",
    height: "385.913px",
    viewBox: "0 0 443.733 385.913",
    style: {
      enableBackground: "new 0 0 443.733 385.913"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuals);
export default __webpack_public_path__ + "static/media/manuals.3ab8ce58.svg";
export { ForwardRef as ReactComponent };